<template>
  <div class="">
    <!-- AGREGAR PRODUCTO -->
    <vs-popup title="Agregar Producto" :active.sync="isPromptActiveLocal">

      <div class="imgContainer imgContainer-m mx-auto">
        <img :src="getImgDual(`${SelectedProduct.id}-1`)">
         <!-- v-if="SelectedProduct.id" -->
      </div>

      <div class="flex" style="justify-content: space-around;" v-if="selectedProductIndex != null">
        <div class="mb-2">
          <p>Precio unitario: ${{ showPrice(SelectedProduct.price) }}</p>
        </div>
        <div class="mb-2">
          <p>Precio Total: ${{ showPrice(SelectedProduct.price * amount) }}</p>
        </div>
        <div class="mb-2">
          <p>Stock: {{ SelectedProduct.stock }}</p>
        </div>
      </div>

      <vs-row vs-w="12">


        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9" class="mb-3">
          <vs-select autocomplete class="w-full" label="Producto" v-model="selectedProductIndex">
            <vs-select-item :key="index" :value="index" :text="Prod.fullName" v-for="(Prod,index) in filteredProductList"/>
          </vs-select>
        </vs-col>


        <vs-col vs-type="" vs-w="3" class="mb-3">
          <vs-input class="w-full" type="number" label="Cantidad" variant="primary" v-model="amount" min="1"
          @change="amount = amount <= 1 ? 1 : amount"></vs-input>
        </vs-col>

      </vs-row>

      <div class="helpText">
        * Si no aparece en la lista, ya está en la compra *
      </div>


      <div class="flex w-full mt-4">
        <vs-button type="border" color="danger" class="mr-2" style="margin-left: auto;"
        @click="isPromptActiveLocal = false">
          Cancelar
        </vs-button>
        <vs-button type="border" @click="addProduct()">
        <!-- :disabled="!validateAddProd" -->
          Confirmar
        </vs-button>
      </div>

    </vs-popup>
  </div>
</template>

<script>
export default {
  props: {
    isPromptActive: { type: Boolean, required: true, },
    SelectedSale: { type: Object, required: true, },
    SaleProductsList: { type: Array, required: true, },
  }, // PROPS
  data() {
    return {
      selectedProductIndex: null,
      amount: 1,
      filteredProductList: [],
    }; // return DATA
  }, // DATA

  computed: {
    isPromptActiveLocal: {
      get() {
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit('closePrompt');
          this.selectedProductIndex = null;
          this.amount = 1;
        }
      }
    },
    SelectedProduct() {
      if (this.selectedProductIndex == null) return {};
      console.log(this.filteredProductList[this.selectedProductIndex]);
      return this.filteredProductList[this.selectedProductIndex];
    },
  }, // COMPUTED

  watch: {
    isPromptActive(val) {
      if (!val) return;
      let productList = this.allProductsList;
      let filteredList = []
      for (let Product of productList) {
        let isInList = false;
        for (let SaleProd of this.SaleProductsList) {
          if (Product.id == SaleProd.productID) isInList = true;
        }
        if (!isInList) {
          filteredList.push(Product);
        }
      }
      this.filteredProductList = filteredList;

    }
  }, // WATCH

  mounted() {
    this.loadProducts()
  },

  methods: {
    // addProduct
    // loadProducts
    addProduct() {
      try {
        let Params = {
          productID: this.SelectedProduct.id,
          price: this.SelectedProduct.price,
          amount: this.amount,
          relevance: this.SaleProductsList.length+1,
          isAdded: 1,
          websiteZoneID: this.dataDB.StockChangesWebsiteZoneIDs.addProduct,
        }
        // Agregar producto a BD y despues a hacer llamada por API para actualizar DOM, ya que tiene una ID
        this.$emit('addSaleItemDB', Params);
      } catch (error) {
        this.myNotify('danger', 'Error', 'Un error ha ocurrido!')
        console.log(error, error.response)
      } finally {
        this.isPromptActiveLocal = false
      }
    },
    loadProducts() {
      const vm = this;
      this.conectToDB({
        file: 'Products', action: 'getProduct', params:  { isActive: 1 },
        success: function(res){
          if (res.data.error) { console.log(res.data.data); return; }
          //console.log('Products:');
          //console.log(res.data.data);
          vm.allProductsList = res.data.data;
        }, error: function(error) { vm.myNotify('danger', 'Error', error); },
      });
    },
  }, // METHODS

} // export default
</script>

<style lang="css" scoped>
.imgContainer {
  margin-top: 25px;
  margin-bottom: 25px;
}
.helpText {
  opacity: 0.7;
  text-align: center;
  font-style: italic;
}
</style>
